import React from 'react'
import ReportHeader from 'components/ReportHeader'
import { connect } from 'react-redux'
import Button from 'components/Button'
import Icon from 'components/Icon'
import PropTypes from 'prop-types'
import { selectNavigationRange } from 'containers/Navigation/selectors'
import { selectVisibleLocationIds } from 'containers/Locations/selectors'
import { FormattedMessage } from 'react-intl'
import MonthlyEvaluationProfilesDropdown from './MonthlyEvaluationProfilesDropdown'
import { selectVisibleProfiles } from './selectors'

const Header = ({ locationIds, profiles, timePeriod }) => {
  let url = '/reports/monthly_evaluations/xlsx.xlsx?time_period=' + JSON.stringify(timePeriod)
  if (locationIds.length > 0) {
    url += '&location_ids=' + locationIds.join(',')
  }
  if (profiles.length > 0) {
    url += '&profiles=' + profiles.join(',')
  }

  return (
    <FormattedMessage id='reports.monthlyEvaluation.name'>
      {text => (
        <ReportHeader name={text}>
          <MonthlyEvaluationProfilesDropdown />
          <div style={{ marginLeft: 10 }}>
            <a
              href={url}
              format='xlsx'
              style={{ display: 'contents' }}
              target='_blank'
            >
              <Button color='success'>
                <Icon name='download' />
                &nbsp; XLS
              </Button>
            </a>
          </div>
        </ReportHeader>
      )}
    </FormattedMessage>
  )
}

Header.propTypes = {
  locationIds: PropTypes.array,
  profiles: PropTypes.array,
  timePeriod: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  locationIds: selectVisibleLocationIds(state),
  timePeriod: selectNavigationRange(state),
  profiles: selectVisibleProfiles(state)
})

export default connect(mapStateToProps)(Header)
